import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('SearchParams')
export class SearchParams {
    @JsonProperty('page', Number)
    page = 1;

    @JsonProperty('search', String)
    search = '';

    @JsonProperty('joined_date_from', Date, true)
    fromDate: Date;

    @JsonProperty('joined_date_to', Date, true)
    toDate: Date;
}
